import React from "react"
import mount from "core/mount"
import CKLOGO from "./convertkit-logo-red.svg"
import KitLogo from "./kit-logo-blue.svg"
import PrimaryNav from "./primary-nav"
import MobileNav from "./mobile-nav"
import SettingsNav from "./settings-nav"
import Container from "core/container"
import VisuallyHidden from "@reach/visually-hidden"
import useFeature from "hooks/use-feature"
import "./tertiary/back-btn"
import "./navigation.css"

export default function Navigation({ userInfo }) {
  const rebrand = useFeature.static("rebrand_2024") // [AFTER REBRAND] Clean up flipper

  return (
    <div
      className="text-white bg-blue-800 overflow-x-hidden bg-kit-white border-b border-gray-200"
      style={{ padding: "12px 0" }}
    >
      <Container>
        <div className="flex justify-between items-center relative">
          <div className="flex gap-12 items-center">
            {rebrand.enabled ? (
              <a href="/" className="block" style={{ width: 54 }}>
                <KitLogo />
                <VisuallyHidden>Kit</VisuallyHidden>
              </a>
            ) : (
              <a id="convertkit-logo" href="/" className="block w-8 h-8">
                <CKLOGO
                  width="32"
                  height="32"
                  className="text-red-500"
                  arial-label="ConvertKit logo"
                />
                <VisuallyHidden>ConvertKit</VisuallyHidden>
              </a>
            )}
            <PrimaryNav />
          </div>
          <MobileNav userInfo={userInfo} />
          <SettingsNav userInfo={userInfo} />
        </div>
      </Container>
    </div>
  )
}

mount({ Navigation })
